import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateStratum = createAsyncThunk(
  "updateStratum",
  async ({ id, data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.patch(
      `stratum/update?id=${id}`,
      data,
      config
    );

    form.resetFields();
    message.success("Stratum successfully updated!");
    history("/app/employee/stratum");
    return response.data;
  }
);

const stratumUpdateSlice = createSlice({
  name: "stratumUpdate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateStratum.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateStratum.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(updateStratum.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default stratumUpdateSlice.reducer;